// @givmo/app-charity — profile route path + the page's address contract (CPA-WEB6 · PE-WEB1).
//
// Single source of truth for the profile destination so the route tree (routes.tsx), the nav shell
// (console-nav.ts), and any `navigate({ to })` calls all agree. Kept as a plain string constant (not a
// TanStack route object) to avoid an import cycle with the route tree — mirrors CLAIM/PAYMENT_ROUTES.
//
// The tabbed page mirrors its active tab into the address (`?tab=details|content|public`, the tab
// labels' own words — D-PE-17 (7)), so a tab is deep-linkable and survives a reload. The words are
// the package's (`PROFILE_TAB_SEARCH`); anything else in `tab` is ignored, never an error, and the
// page opens on its default tab.

import {
  profileTabFromSearch,
  profileTabToSearch,
  type ProfileTabSearch,
} from '@givmo/org-console';

export const PROFILE_ROUTES = {
  /** Profile editor — the charity's mission / website / contact / logo + the read-only verification domain. */
  editor: '/profile',
  /** The Public tab's QR design page (PE-WEB11) — the QR card's "Customize". */
  qr: '/profile/qr',
} as const;

export interface ProfileSearch {
  tab?: ProfileTabSearch;
}

/** The route's `validateSearch`: keeps a known tab word, drops anything else. */
export function parseProfileSearch(search: Record<string, unknown>): ProfileSearch {
  const tab = profileTabFromSearch(search.tab);
  return tab === null ? {} : { tab: profileTabToSearch(tab) };
}
